import { DisconnectOutlined } from '@ant-design/icons';
import { useAuth } from 'auth/AuthContext';
import AuthContainer from 'components/containers/AuthContainer';
import { Button } from 'components/ui/button';
import { Spinner } from 'components/ui/spinner';
import posthog from 'posthog-js';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { routes } from 'services/RouteService';

export default function WelcomePage() {
  // Hooks
  const { status, tryToLoginFromStoredTokens } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <AuthContainer
      title={t('loginRegister.welcome.title')}
      description={t('loginRegister.welcome.description')}
      mode="login"
      bottomLinkTo="none"
      displayLogo
    >
      {status === 'loading' ? (
        <div className="flex h-full items-center justify-center">
          <Spinner className="size-8" />
        </div>
      ) : (
        <div className="flex flex-col gap-3">
          <Button size="xl" className="w-full" onClick={() => navigate(routes.login.route, { state: location.state })}>
            {t('loginRegister.actions.login')}
          </Button>
          <Button variant="secondary" size="xl" className="w-full" onClick={() => navigate(routes.register.route)}>
            {t('loginRegister.actions.register')}
          </Button>
        </div>
      )}
      {status === 'error' && (
        <div className="mt-16 flex flex-col items-center justify-center gap-3">
          <DisconnectOutlined className="text-3xl text-destructive-text" />
          <p className="mt-3 text-center text-destructive-text">{t('loginRegister.errors.errorOccurred')}</p>
          <Button
            size="lg"
            onClick={() => {
              tryToLoginFromStoredTokens();
              posthog.capture('login.retry_on_error');
            }}
          >
            {t('loginRegister.actions.retry')}
          </Button>
        </div>
      )}
    </AuthContainer>
  );
}
